class QuickViewDrawer extends MenuDrawer {
  constructor() {
    super();

    this.setClasses({
      open: 'quick-view--open',
      opening: 'quick-view--opening',
      closing: 'quick-view--closing'
    });

    this.addEventListener('close', () => {
      const drawerContent = this.querySelector('.quick-view__content');
      drawerContent.innerHTML = '';
      drawerContent.classList.remove('hide-cover');

      document.dispatchEvent(new CustomEvent('quickview:close'));
    });
  }

  openMenuDrawer(summaryElement = false) {
    super.openMenuDrawer(summaryElement);
    removeTrapFocus();
    clearTimeout(this.focusTimer);
    this.focusTimer = setTimeout(() => {
      if (!this.mainDetailsToggle.hasAttribute('open')) return;
      const content = this.querySelector('.quick-view__content');
      this.dialogFocus = new ThemeDialogFocus(content, () => this.closeMenuDrawer({}));
      this.dialogFocus.activate();
      this.dialogFocus.previousFocus = this.opener || summaryElement;
    }, 450);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    clearTimeout(this.focusTimer);
    super.closeMenuDrawer(event, elementToFocus);
    this.dialogFocus?.deactivate();
  }

  disconnectedCallback() {
    clearTimeout(this.focusTimer);
    this.dialogFocus?.deactivate();
  }
}
customElements.define('quick-view-drawer', QuickViewDrawer);

class QuickViewButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      const wrapper = this.closest('.card-wrapper');
      const drawer = wrapper.querySelector('quick-view-drawer');
      if (drawer) {
        drawer.opener = event.target.closest('button') || this;
        drawer.querySelector('summary').click();

        document.dispatchEvent(new CustomEvent('quickview:open', {
          detail: {
            productUrl: this.dataset.productUrl
          }
        }));
      }
      else if (this.dataset.productUrl) {
        window.location.href = this.dataset.productUrl;
      }
    });
  }

  connectedCallback() {
    // A cached recommendation fragment may still contain the legacy custom control.
    queueMicrotask(() => {
      if (this.querySelector('button')) return;
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'card-action';
      while (this.firstChild) button.appendChild(this.firstChild);
      this.appendChild(button);
    });
  }
}
customElements.define('quick-view-button', QuickViewButton);

class QuickView extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, _observer) {
    if (!entries[0].isIntersecting) return;

    const selector = '.quick-view__content';
    const drawerContent = this.querySelector(selector);
    const productUrl = this.dataset.productUrl.split('?')[0];
    const sectionUrl = `${productUrl}?view=modal`;

    fetch(sectionUrl)
      .then(response => response.text())
      .then(responseText => {
        setTimeout(() => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const productElement = responseHTML.querySelector(selector);
          this.setInnerHTML(drawerContent, productElement.innerHTML);

          if (window.Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
        }, 200);

        setTimeout(() => {
          drawerContent.classList.add('hide-cover');

          document.dispatchEvent(new CustomEvent('quickview:loaded', {
            detail: {
              productUrl: this.dataset.productUrl
            }
          }));
        }, 500);
      })
      .catch(e => {
        console.error(e);
      });
  }

  setInnerHTML(element, html) {
    element.innerHTML = html;

    // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
    element.querySelectorAll('script').forEach(oldScriptTag => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach(attribute => {
        newScriptTag.setAttribute(attribute.name, attribute.value)
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}
customElements.define('quick-view', QuickView);
